<template>
  <div id="recommand-app-modal" class="modal fade" :class="{'is-open': open}">
    <div
      class="modal-dialog"
      style="width: 700px; height:50px; position: absolute; top: 50%; left: 50%;margin: -200px 0 0 -350px;"
    >
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-12 pl-0">
            <h3 class="modal-title">網路服務推薦連結</h3>
          </div>
        </div>
        <div class="modal-body" style="min-height: 50px;">
          <!-- 會員/網路服務資格-->
          <table id="recommendAppTable">
            <tr>
              <td>
                <span style="font-size:23px;font-weight:600">推薦下載國泰人壽APP:</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:20px;font-weight:400; margin-left:20px;">推薦下載國泰人壽APP:</span>
              </td>
              <td>
                <input
                  type="text"
                  style="position:absolute;left:-10000px;top:-10000px"
                  id="copyText"
                />
                <button
                  type="button"
                  style="font-size:20px"
                  class="btn btn-default btn-sm"
                  @click="copy(mmlUrl)"
                >複製連結</button>
              </td>
              <td>
                <i
                  class="icon-facebook"
                  style="cursor:pointer;"
                  @click="encodeLink('fb', fbMetaUrl)"
                ></i>
              </td>
              <td>
                <i class="icon-line" style="cursor:pointer;" @click="encodeLink('line', mmlUrl)"></i>
              </td>
            </tr>
              <td style="height:20px;">
              </td>
            <tr>
            </tr>
            <tr>
              <td>
                <span style="font-size:23px;font-weight:600">網路服務開通:</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="font-size:20px;font-weight:400; margin-left:20px;">推薦以「雙證件拍照」開通網路服務:</span>
              </td>
              <td>
                <input
                  type="text"
                  style="position:absolute;left:-10000px;top:-10000px"
                  id="copyText"
                />
                <button
                  type="button"
                  style="font-size:20px"
                  class="btn btn-default btn-sm"
                  @click="copy(credentialsText)"
                >複製連結</button>
              </td>
              <td>
                <i
                  class="icon-facebook"
                  style="cursor:pointer;"
                  @click="encodeLink('fb', credentialsUrl)"
                ></i>
              </td>
              <td>
                <i class="icon-line" style="cursor:pointer;" @click="encodeLink('line', credentialsText)"></i>
              </td>
            </tr>
            <!--<tr>
              <td>
                <span style="font-size:20px;font-weight:400; margin-left:20px;">推薦以「國泰世華網銀認證」開通網路服務:</span>
              </td>
              <td>
                <input
                  type="text"
                  style="position:absolute;left:-10000px;top:-10000px"
                  id="copyText"
                />
                <button
                  type="button"
                  style="font-size:20px"
                  class="btn btn-default btn-sm"
                  @click="copy(bankText)"
                >複製連結</button>
              </td>
              <td>
                <i
                  class="icon-facebook"
                  style="cursor:pointer;"
                  @click="encodeLink('fb', bankUrl)"
                ></i>
              </td>
              <td>
                <i class="icon-line" style="cursor:pointer;" @click="encodeLink('line', bankText)"></i>
              </td>
            </tr>-->
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";

export default {
  name: "RecommandAppModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    mmlUrl: {
      type: String,
      default: ""
    },
    fbMetaUrl: {
      type: String,
      default: ""
    },
    credentialsUrl: {
      type: String,
      default: ""
    },
    credentialsText: {
      type: String,
      default: ""
    },
    bankUrl: {
      type: String,
      default: ""
    },
    bankText: {
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    }
  },
  data() {
    return {};
  },
  methods: {
    //判斷是line還是FB
    encodeLink(type, link) {
      if (this.isBox) {
        this.boxCathayShareLink(link);
      } else {
        let str = encodeURI(link);
        let url =
          type === "fb"
            ? `http://www.facebook.com/share.php?u=${str}`
            : `http://line.naver.jp/R/msg/text/?${str}`;
        window.open(url);
      }
    },
    //複製連結
    copy(url) {
      if (this.isBox) {
        this.boxCathayShareLink(url);
      } else {
        const copyText = document.getElementById("copyText");
        copyText.value = url;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (document.execCommand("cut")) {
          this.$toast.info({ title: "連結已複製" });
        } else {
          console.error("複製失敗");
        }
      }
    }
  }
};
</script>
